import { render, staticRenderFns } from "./exam-update.vue?vue&type=template&id=ba261034&"
import script from "./exam-update.vue?vue&type=script&lang=js&"
export * from "./exam-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports